<template>
              <v-overlay
            :relative="relative"
            :value="overlayy"
          >

          <div class="overlay p-3 border border-primary shadow p-3 m-5 bg-white rounded">
            <span class="closebtn-subianco" @click="closeOverlay()" >&times;</span>
            <p>seleziona uno stato</p>
             <div class="mx-5 my-2" v-for="stat in status" :key="stat">
                 <input class="form-check-input" type="radio" name="statoRadio" :value="stat" v-model="selectedstato" >
             <label class="form-check-label d-flex flex-row" for="statoRadio">
<span class="item-dot m-1" :stato="stat" id="item-dot" ></span>
<h5 class="textd" :stato="stat"></h5>
</label>
</div>
             <button class="botton-secondary d-inline mt-0" type="submit" @click="cambiaStato( selected, selectedstato)">  Conferma</button></div>

          </v-overlay>
</template>

<script>

import SegnalazioniDataService from '@/service/SegnalazioniDataService.js'

export default {
  name: 'segnalazioniComune',
  props: ['overlay', 'segnalazioneid', 'codcomune'],
  data () {
    return {
      relative: true,
      overlayy: this.overlay,
      selected: this.segnalazioneid,
      selectedstato: null,
      status: ['NON_VERIFICATA', 'VERIFICATA', 'IN_CODA', 'IN_CARICO', 'RISOLTA', 'RIFIUTATA', 'ARCHIVIATA']
    }
  },
  methods: {
    closeOverlay () {
      this.$emit('close')
    },
    cambiaStato (id, s) {
      console.log(s)
      SegnalazioniDataService.update(id, s)
        .then(response => {
          console.log(response.data)
          const path = '/backoffice/' + this.codcomune + '?segnalazione=STATOAGGIORNATO'
          this.$router.push(path)
          this.closeOverlay()
        })
        .catch(e => {
          console.log(e)
        })
    }
  },

  watch: {
    overlay: function (overly) {
      console.log('overly -->', overly)
      this.overlayy = overly
      console.log(this.overlayy)
    },
    segnalazioneid: function (segid) {
      console.log('segnalazioneid -->', segid)
      this.selected = segid
      console.log(this.selected)
    }

  }
}
</script>
